// extracted by mini-css-extract-plugin
module.exports = {"listsWrapper":"KanBoLists_listsWrapper__2RILb","listsContainer":"KanBoLists_listsContainer__1qC28","lists":"KanBoLists_lists__UsQLH"};